query CouponProductModules {
    black5ProductModules {
        dateEnd
        id
        status
        template
        products {
            currencyId
            days
            id
            image
            keyword
            model
            name
            nights
            recommend
            cities {
                name
            }
            packagePrice {
                finalPrice {
                    hasDiscount
                    amount {
                        rawValue
                        value
                    }
                    discount {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                    discountList {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                }
                salePrice {
                    hasDiscount
                    amount {
                        rawValue
                        value
                    }
                    discount {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                    discountList {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                }
            }
            tags {
                id
                image
                name
            }
            tourPrice {
                finalPrice {
                    hasDiscount
                    amount {
                        rawValue
                        value
                    }
                    discount {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                    discountList {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                }
                salePrice {
                    hasDiscount
                    amount {
                        rawValue
                        value
                    }
                    discount {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                    discountList {
                        type
                        ... on FlatDiscount {
                            type
                            amountOff {
                                rawValue
                                value
                            }
                        }
                        ... on PercentDiscount {
                            percentOff
                            type
                        }
                    }
                }
            }
        }
    }
}
